import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  LIST_getInstance2leq5bbahk4rz as LIST_getInstance,
  MAP_getInstance141vh6u7faopd as MAP_getInstance,
} from '../descriptors/SerialKinds.mjs';
import { toIntOrNull3w2d066r9pvwm as toIntOrNull } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from '../descriptors/SerialDescriptor.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var LinkedHashSetClassDescClass;
function LinkedHashSetClassDesc() {
  if (LinkedHashSetClassDescClass === VOID) {
    class $ extends ListLikeDescriptor() {
      u1n() {
        return 'kotlin.collections.LinkedHashSet';
      }
    }
    initMetadataForClass($, 'LinkedHashSetClassDesc');
    LinkedHashSetClassDescClass = $;
  }
  return LinkedHashSetClassDescClass;
}
var ArrayListClassDescClass;
function ArrayListClassDesc() {
  if (ArrayListClassDescClass === VOID) {
    class $ extends ListLikeDescriptor() {
      u1n() {
        return 'kotlin.collections.ArrayList';
      }
    }
    initMetadataForClass($, 'ArrayListClassDesc');
    ArrayListClassDescClass = $;
  }
  return ArrayListClassDescClass;
}
var HashSetClassDescClass;
function HashSetClassDesc() {
  if (HashSetClassDescClass === VOID) {
    class $ extends ListLikeDescriptor() {
      u1n() {
        return 'kotlin.collections.HashSet';
      }
    }
    initMetadataForClass($, 'HashSetClassDesc');
    HashSetClassDescClass = $;
  }
  return HashSetClassDescClass;
}
var HashMapClassDescClass;
function HashMapClassDesc() {
  if (HashMapClassDescClass === VOID) {
    class $ extends MapLikeDescriptor() {
      constructor(keyDesc, valueDesc) {
        super('kotlin.collections.HashMap', keyDesc, valueDesc);
      }
    }
    initMetadataForClass($, 'HashMapClassDesc');
    HashMapClassDescClass = $;
  }
  return HashMapClassDescClass;
}
var LinkedHashMapClassDescClass;
function LinkedHashMapClassDesc() {
  if (LinkedHashMapClassDescClass === VOID) {
    class $ extends MapLikeDescriptor() {
      constructor(keyDesc, valueDesc) {
        super('kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
      }
    }
    initMetadataForClass($, 'LinkedHashMapClassDesc');
    LinkedHashMapClassDescClass = $;
  }
  return LinkedHashMapClassDescClass;
}
var ArrayClassDescClass;
function ArrayClassDesc() {
  if (ArrayClassDescClass === VOID) {
    class $ extends ListLikeDescriptor() {
      u1n() {
        return 'kotlin.Array';
      }
    }
    initMetadataForClass($, 'ArrayClassDesc');
    ArrayClassDescClass = $;
  }
  return ArrayClassDescClass;
}
var ListLikeDescriptorClass;
function ListLikeDescriptor() {
  if (ListLikeDescriptorClass === VOID) {
    class $ {
      constructor(elementDescriptor) {
        this.u1t_1 = elementDescriptor;
        this.v1t_1 = 1;
      }
      n1p() {
        return LIST_getInstance();
      }
      p1p() {
        return this.v1t_1;
      }
      r1p(index) {
        return index.toString();
      }
      s1p(name) {
        var tmp0_elvis_lhs = toIntOrNull(name);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalArgumentException().n2(name + ' is not a valid list index');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      v1p(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.u1n() + ' expects only non-negative indices';
          throw IllegalArgumentException().n2(toString(message));
        }
        return false;
      }
      t1p(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.u1n() + ' expects only non-negative indices';
          throw IllegalArgumentException().n2(toString(message));
        }
        return emptyList();
      }
      u1p(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.u1n() + ' expects only non-negative indices';
          throw IllegalArgumentException().n2(toString(message));
        }
        return this.u1t_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListLikeDescriptor()))
          return false;
        if (equals(this.u1t_1, other.u1t_1) && this.u1n() === other.u1n())
          return true;
        return false;
      }
      hashCode() {
        return imul(hashCode(this.u1t_1), 31) + getStringHashCode(this.u1n()) | 0;
      }
      toString() {
        return this.u1n() + '(' + toString(this.u1t_1) + ')';
      }
    }
    protoOf($).g1p = get_isNullable;
    protoOf($).o1p = get_isInline;
    protoOf($).q1p = get_annotations;
    initMetadataForClass($, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor()]);
    ListLikeDescriptorClass = $;
  }
  return ListLikeDescriptorClass;
}
var MapLikeDescriptorClass;
function MapLikeDescriptor() {
  if (MapLikeDescriptorClass === VOID) {
    class $ {
      constructor(serialName, keyDescriptor, valueDescriptor) {
        this.a1u_1 = serialName;
        this.b1u_1 = keyDescriptor;
        this.c1u_1 = valueDescriptor;
        this.d1u_1 = 2;
      }
      u1n() {
        return this.a1u_1;
      }
      n1p() {
        return MAP_getInstance();
      }
      p1p() {
        return this.d1u_1;
      }
      r1p(index) {
        return index.toString();
      }
      s1p(name) {
        var tmp0_elvis_lhs = toIntOrNull(name);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw IllegalArgumentException().n2(name + ' is not a valid map index');
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      v1p(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.u1n() + ' expects only non-negative indices';
          throw IllegalArgumentException().n2(toString(message));
        }
        return false;
      }
      t1p(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.u1n() + ' expects only non-negative indices';
          throw IllegalArgumentException().n2(toString(message));
        }
        return emptyList();
      }
      u1p(index) {
        // Inline function 'kotlin.require' call
        if (!(index >= 0)) {
          var message = 'Illegal index ' + index + ', ' + this.u1n() + ' expects only non-negative indices';
          throw IllegalArgumentException().n2(toString(message));
        }
        var tmp;
        switch (index % 2 | 0) {
          case 0:
            tmp = this.b1u_1;
            break;
          case 1:
            tmp = this.c1u_1;
            break;
          default:
            // Inline function 'kotlin.error' call

            var message_0 = 'Unreached';
            throw IllegalStateException().o(toString(message_0));
        }
        return tmp;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MapLikeDescriptor()))
          return false;
        if (!(this.u1n() === other.u1n()))
          return false;
        if (!equals(this.b1u_1, other.b1u_1))
          return false;
        if (!equals(this.c1u_1, other.c1u_1))
          return false;
        return true;
      }
      hashCode() {
        var result = getStringHashCode(this.u1n());
        result = imul(31, result) + hashCode(this.b1u_1) | 0;
        result = imul(31, result) + hashCode(this.c1u_1) | 0;
        return result;
      }
      toString() {
        return this.u1n() + '(' + toString(this.b1u_1) + ', ' + toString(this.c1u_1) + ')';
      }
    }
    protoOf($).g1p = get_isNullable;
    protoOf($).o1p = get_isInline;
    protoOf($).q1p = get_annotations;
    initMetadataForClass($, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor()]);
    MapLikeDescriptorClass = $;
  }
  return MapLikeDescriptorClass;
}
var PrimitiveArrayDescriptorClass;
function PrimitiveArrayDescriptor() {
  if (PrimitiveArrayDescriptorClass === VOID) {
    class $ extends ListLikeDescriptor() {
      constructor(primitive) {
        super(primitive);
        this.i1u_1 = primitive.u1n() + 'Array';
      }
      u1n() {
        return this.i1u_1;
      }
    }
    initMetadataForClass($, 'PrimitiveArrayDescriptor');
    PrimitiveArrayDescriptorClass = $;
  }
  return PrimitiveArrayDescriptorClass;
}
//region block: exports
export {
  ArrayClassDesc as ArrayClassDesc2voesact8ugbc,
  ArrayListClassDesc as ArrayListClassDesc2euexqfjnihq7,
  HashMapClassDesc as HashMapClassDesc33bep136pd9y6,
  HashSetClassDesc as HashSetClassDesc1sva99tssxbb4,
  LinkedHashMapClassDesc as LinkedHashMapClassDesc1yxtovbec4ruk,
  LinkedHashSetClassDesc as LinkedHashSetClassDesc202cqq5740j6e,
  PrimitiveArrayDescriptor as PrimitiveArrayDescriptor3bvg9e2uulc3b,
};
//endregion

//# sourceMappingURL=CollectionDescriptors.mjs.map
